var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-app-wrap on-touch"},[_c('div',{staticClass:"v-overlay__small"},[_c('ScreenTooSmall')],1),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.getShowPromotionStatus)?_c('Promotion'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34679e3d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 